// ══════════════════════════════════════
// DERMIQ v9 — INTRO + CURSOR FIX
// ══════════════════════════════════════

// ── Intro overlay handled inline in theme.liquid for lag-free start



// ── Build Bundle page logic (3 products = 15%, 4+ = no discount)
(function(){
  var rows = document.querySelectorAll('.bpr');
  if (!rows.length) return;
  var selected = [];

  function render(){
    var count = selected.length;
    var countEl = document.getElementById('bpCountEl');
    var selList = document.getElementById('bpSelList');
    var pRow    = document.getElementById('bpPriceRow');
    var dRow    = document.getElementById('bpDiscRow');
    var totEl   = document.getElementById('bpTotalEl');
    var chip    = document.getElementById('bpDiscChip');
    var note    = document.getElementById('bpDiscNote');
    var btn     = document.getElementById('bpAddBtn');

    if (countEl) countEl.textContent = count + ' / 3';
    if (selList) {
      selList.innerHTML = '';
      if (count === 0) {
        selList.innerHTML = '<div class="bundle-sel-empty">Select 3 products to unlock 15% off</div>';
      } else {
        selected.forEach(function(i){
          selList.innerHTML += '<div class="bundle-sel-item"><span>'+i.title+'</span><span>€'+i.price+'</span></div>';
        });
      }
    }

    var total = selected.reduce(function(s,i){ return s + i.price; }, 0);
    var discounted = Math.round(total * 0.85);

    if (count === 3) {
      if (pRow) pRow.innerHTML = '<span>Subtotal</span><span style="text-decoration:line-through;color:var(--lgray)">€'+total+'</span>';
      if (dRow) { dRow.style.display='flex'; dRow.innerHTML = '<span>Bundle saving (15%)</span><span style="color:#000000">−€'+(total-discounted)+'</span>'; }
      if (totEl) totEl.innerHTML = '<span>Total</span><span>€'+discounted+'</span>';
      if (chip) chip.style.display='inline-block';
      if (note) note.style.display='block';
      if (btn) { btn.disabled=false; btn.textContent='Add Bundle to Bag — €'+discounted; }
    } else {
      if (pRow) pRow.innerHTML = '<span>Subtotal</span><span>€'+total+'</span>';
      if (dRow) dRow.style.display='none';
      if (totEl) totEl.innerHTML = '<span>Total</span><span>€'+total+'</span>';
      if (chip) chip.style.display='none';
      if (note) note.style.display='none';
      var need = 3 - count;
      if (btn) { btn.disabled=true; btn.textContent='Select '+need+' more product'+(need!==1?'s':''); }
    }
  }

  rows.forEach(function(row){
    row.addEventListener('click', function(){
      var vid   = parseInt(this.dataset.vid);
      var title = this.dataset.title;
      var price = parseFloat(this.dataset.price);
      var idx = selected.findIndex(function(i){ return i.vid===vid; });
      if (idx >= 0) {
        selected.splice(idx,1);
        this.classList.remove('selected');
      } else {
        selected.push({vid:vid,title:title,price:price});
        this.classList.add('selected');
      }
      render();
    });
  });

  var addBtn = document.getElementById('bpAddBtn');
  if (addBtn) {
    addBtn.addEventListener('click', function(){
      if (selected.length !== 3) return;
      var items = selected.map(function(i){ return {id:i.vid,quantity:1}; });
      var discount = 'BUNDLE-DISCOUNT-15';
      dermiqAddItems(items, this, discount);
    });
  }

  render();
})();

// ── Skin Quiz logic
(function(){
  var quiz = document.getElementById('dermiqQuiz');
  if (!quiz) return;
  var steps      = quiz.querySelectorAll('.quiz-step');
  var result     = quiz.querySelector('.quiz-result');
  var fillEl     = quiz.querySelector('.quiz-bar-fill');
  var stepLbl    = quiz.querySelector('.quiz-step-lbl');
  var current    = 0;
  var answers    = {};

  function showStep(n){
    steps.forEach(function(s,i){ s.classList.toggle('active', i===n); });
    if (fillEl)  fillEl.style.width = ((n / steps.length) * 100) + '%';
    if (stepLbl) stepLbl.textContent = 'Step ' + (n+1) + ' of ' + steps.length;
  }

  quiz.querySelectorAll('.quiz-opt').forEach(function(opt){
    opt.addEventListener('click', function(){
      var step = this.closest('.quiz-step');
      step.querySelectorAll('.quiz-opt').forEach(function(o){ o.classList.remove('chosen'); });
      this.classList.add('chosen');
      answers['q'+current] = this.dataset.value;
      setTimeout(function(){
        if (current < steps.length - 1) { current++; showStep(current); }
        else { showResult(); }
      }, 380);
    });
  });

  function showResult(){
    steps.forEach(function(s){ s.classList.remove('active'); });
    if (result){
      result.classList.add('active');
      if (fillEl) fillEl.style.width = '100%';
      var skin   = answers['q0'] || 'normal';
      var focus  = answers['q1'] || 'hydration';
      var titleMap = {oily:'Perfect for oily & shine-prone skin',dry:'Perfect for dry & dehydrated skin',combo:'Perfect for combination skin',sensitive:'Perfect for sensitive & reactive skin'};
      var descMap  = {aging:'Your personalised anti-aging routine',hydration:'Your personalised hydration routine',brightening:'Your personalised brightening routine',pores:'Your personalised pore-refining routine'};
      var tEl = result.querySelector('.quiz-result-title');
      var dEl = result.querySelector('.quiz-result-desc');
      if (tEl) tEl.textContent = (titleMap[skin] || 'Your personalised routine is ready');
      if (dEl) dEl.textContent = (descMap[focus] || 'We\'ve selected the products that work best for you.') + ' — based on your answers.';
    }
  }

  var prevBtn = quiz.querySelector('.quiz-prev-btn');
  if (prevBtn) prevBtn.addEventListener('click', function(){ if (current>0){ current--; showStep(current); } });

  showStep(0);
})();

// ── Progress bar + scrolled nav
window.addEventListener('scroll', function() {
  var nav = document.getElementById('dermiqNav');
  if (nav) nav.classList.toggle('scrolled', window.scrollY > 40);
  var bar = document.getElementById('dermiqProgress');
  if (bar) {
    var pct = (window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100;
    bar.style.width = pct + '%';
  }
});

// ── Scroll reveal
var obs = new IntersectionObserver(function(entries) {
  entries.forEach(function(e, i) {
    if (e.isIntersecting) {
      setTimeout(function() { e.target.classList.add('visible'); }, i * 55);
      obs.unobserve(e.target);
    }
  });
}, { threshold: 0.1 });
document.querySelectorAll('.reveal').forEach(function(el) { obs.observe(el); });


// ── Toast notification
function dermiqToast(msg) {
  var t = document.getElementById('dermiqToastEl');
  if (!t) {
    t = document.createElement('div');
    t.id = 'dermiqToastEl';
    t.className = 'dermiq-toast';
    document.body.appendChild(t);
  }
  t.textContent = msg;
  t.classList.add('show');
  clearTimeout(t._timer);
  t._timer = setTimeout(function() { t.classList.remove('show'); }, 2800);
}

// ── Update cart count in nav
function dermiqUpdateCartCount() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var el = document.getElementById('cartCount');
      var dot = document.getElementById('cartDot');
      if (el) el.textContent = cart.item_count;
      if (dot) dot.style.display = cart.item_count > 0 ? 'block' : 'none';
      // Notify mini-cart to refresh
      document.dispatchEvent(new CustomEvent('dermiq:cart:updated'));
    });
}

// ── Add single item to cart (AJAX)
function dermiqAddToCart(variantId, quantity, btnEl) {
  quantity = quantity || 1;
  if (btnEl) { btnEl.disabled = true; btnEl.textContent = 'Adding...'; }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: quantity })
  })
  .then(function(r) { return r.json(); })
  .then(function(item) {
    if (item.status) { throw new Error(item.description || 'Error'); }
    dermiqUpdateCartCount();
    // Small delay to ensure Shopify cart is fully updated before we fetch it
    setTimeout(dermiqCheckCartDiscount, 300);
    dermiqToast('Added to bag');
    if (btnEl) {
      btnEl.disabled = false;
      var orig = btnEl.getAttribute('data-orig') || 'Add to Bag';
      btnEl.textContent = 'Added \u2713';
      setTimeout(function() { btnEl.textContent = orig; }, 2200);
    }
  })
  .catch(function(err) {
    dermiqToast('Something went wrong');
    if (btnEl) { btnEl.disabled = false; btnEl.textContent = btnEl.getAttribute('data-orig') || 'Add to Bag'; }
  });
}

// ── Bundle discount helpers ───────────────────────────────────────────────
// Stores { code, ids: [variantId, ...] } so we can verify cart contents

function dermiqSaveBundleState(variantIds, discountCode) {
  try {
    sessionStorage.setItem('dermiqDiscount', discountCode);
    sessionStorage.setItem('dermiqBundleIds', JSON.stringify(variantIds));
  } catch(e) {}
}

function dermiqGetDiscount() {
  try { return sessionStorage.getItem('dermiqDiscount') || ''; } catch(e) { return ''; }
}

function dermiqClearDiscount() {
  try {
    sessionStorage.removeItem('dermiqDiscount');
    sessionStorage.removeItem('dermiqBundleIds');
  } catch(e) {}
}

function dermiqGetBundleIds() {
  try {
    var raw = sessionStorage.getItem('dermiqBundleIds');
    return raw ? JSON.parse(raw) : [];
  } catch(e) { return []; }
}

// Append ?discount=CODE to checkout button(s) on the page
function dermiqWireDiscountLinks(code) {
  code = code !== undefined ? code : dermiqGetDiscount();
  document.querySelectorAll('.checkout-btn, #cartCheckoutBtn').forEach(function(el) {
    var base = '/checkout';
    el.setAttribute('href', code ? base + '?discount=' + encodeURIComponent(code) : base);
  });
}

// Fetch current cart, compare to stored bundle IDs, apply or clear discount
function dermiqCheckCartDiscount() {
  var code      = dermiqGetDiscount();
  var bundleIds = dermiqGetBundleIds();
  var banner    = document.getElementById('dermiqDiscountBanner');

  if (!code || !bundleIds.length) {
    dermiqWireDiscountLinks('');
    if (banner) banner.style.display = 'none';
    return;
  }

  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var cartIds = (cart.items || []).map(function(i) { return i.variant_id; });
      // Check if every cart item is one of the bundled variants
      var allBundle = cartIds.every(function(id) {
        return bundleIds.indexOf(id) !== -1;
      });

      if (allBundle && cartIds.length > 0) {
        // All items are bundle items — apply discount
        dermiqWireDiscountLinks(code);
        if (banner) {
          var pct = code.indexOf('18') !== -1 ? '18' : '15';
          banner.textContent = 'Bundle discount active \u2014 ' + pct + '% off at checkout';
          banner.className = 'dermiq-discount-banner active';
          banner.style.display = 'block';
        }
      } else {
        // Non-bundle item in cart — pause discount (keep in sessionStorage so it can be restored)
        dermiqWireDiscountLinks('');
        if (banner) {
          banner.textContent = 'Bundle discount paused \u2014 remove individual items to restore';
          banner.className = 'dermiq-discount-banner removed';
          banner.style.display = 'block';
        }
      }
    })
    .catch(function() {});
}

// Run on every page load
document.addEventListener('DOMContentLoaded', function() {
  dermiqCheckCartDiscount();
});

// ── Add multiple items to cart at once (bundles)
function dermiqAddItems(items, btnEl, discountCode) {
  if (!items || !items.length) {
    dermiqToast('Products not available yet');
    return;
  }
  var valid = items.filter(function(i) { return i.id && i.id > 0; });
  if (!valid.length) {
    dermiqToast('Please add products to your store first');
    return;
  }
  if (btnEl) { btnEl.disabled = true; btnEl.textContent = 'Adding...'; }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: valid })
  })
  .then(function(r) { return r.json(); })
  .then(function(result) {
    if (result.status) { throw new Error(result.description || 'Error'); }
    dermiqUpdateCartCount();
    if (discountCode) {
      var bundleVids = valid.map(function(i) { return i.id; });
      dermiqSaveBundleState(bundleVids, discountCode);
      dermiqWireDiscountLinks(discountCode);   // update checkout btn on current page immediately
      var pct = discountCode.indexOf('18') !== -1 ? '18' : '15';
      dermiqToast('Bundle added \u2713  ' + pct + '% discount applied at checkout');
    } else {
      dermiqToast('Bundle added to bag \u2713');
    }
    if (btnEl) {
      btnEl.disabled = false;
      var orig = btnEl.getAttribute('data-orig') || 'Add Bundle to Bag';
      btnEl.textContent = 'Added \u2713';
      setTimeout(function() { btnEl.textContent = orig; }, 2500);
    }
  })
  .catch(function() {
    dermiqToast('Something went wrong');
    if (btnEl) { btnEl.disabled = false; btnEl.textContent = btnEl.getAttribute('data-orig') || 'Add Bundle to Bag'; }
  });
}

// ── Bundle button handler (reads data-v1…data-count + data-discount)
function dermiqAddBundleItems(btn) {
  var count    = parseInt(btn.getAttribute('data-count')) || 0;
  var discount = btn.getAttribute('data-discount') || '';
  var items = [];
  for (var i = 1; i <= count; i++) {
    var vid = parseInt(btn.getAttribute('data-v' + i));
    if (vid) items.push({ id: vid, quantity: 1 });
  }
  dermiqAddItems(items, btn, discount);
}

// ── Product page: add to cart form
var productForm = document.getElementById('dermiqProductForm');
if (productForm) {
  productForm.addEventListener('submit', function(e) {
    e.preventDefault();
    var variantId = parseInt(this.querySelector('[name="id"]').value);
    var qty = parseInt(this.querySelector('[name="quantity"]').value) || 1;
    var btn = this.querySelector('.add-to-cart-btn');
    dermiqAddToCart(variantId, qty, btn);
    // Show "View Bag" link after success
    setTimeout(function() {
      var vl = document.getElementById('viewCartLink');
      if (vl) vl.style.display = 'inline';
    }, 1200);
  });
}

// ── Custom bundle chip selector
function dermiqToggleChip(chip) {
  var selected = document.querySelectorAll('#dermiqCustomSelector .selected');
  if (chip.classList.contains('selected')) {
    chip.classList.remove('selected');
  } else {
    if (selected.length >= 3) { selected[0].classList.remove('selected'); }
    chip.classList.add('selected');
  }
  dermiqUpdateCustomBundle();
}

function dermiqUpdateCustomBundle() {
  var chips = Array.prototype.slice.call(document.querySelectorAll('#dermiqCustomSelector .selected'));
  var total = chips.reduce(function(s, c) { return s + parseFloat(c.dataset.price); }, 0);
  var discounted = Math.round(total * 0.85 * 100) / 100;
  var btn = document.getElementById('dermiqCustomBtn');
  var priceEl = document.getElementById('dermiqCustomPrice');
  var origEl  = document.getElementById('dermiqCustomOriginal');
  var saveEl  = document.getElementById('dermiqCustomSave');
  if (!btn) return;
  if (chips.length === 3) {
    if (priceEl) priceEl.textContent = '\u20ac' + discounted.toFixed(0);
    if (origEl)  origEl.textContent  = '\u20ac' + total.toFixed(0);
    if (saveEl)  saveEl.textContent  = 'Save 15%';
    btn.disabled = false;
    btn.style.opacity = '1';
    btn.style.cursor = 'pointer';
    btn.textContent = 'Add Bundle to Bag';
  } else {
    if (priceEl) priceEl.textContent = '--';
    if (origEl)  origEl.textContent  = '';
    if (saveEl)  saveEl.textContent  = '';
    btn.disabled = true;
    btn.style.opacity = '.4';
    btn.style.cursor = 'not-allowed';
    var rem = 3 - chips.length;
    btn.textContent = 'Select ' + rem + ' more product' + (rem !== 1 ? 's' : '');
  }
}

// ── Custom bundle: add selected chips to cart
function dermiqAddCustomBundle(btn) {
  var chips    = Array.prototype.slice.call(document.querySelectorAll('#dermiqCustomSelector .selected'));
  var discount = btn.getAttribute('data-discount') || '';
  var items    = chips.map(function(c) {
    return { id: parseInt(c.getAttribute('data-vid')), quantity: 1 };
  });
  dermiqAddItems(items, btn, discount);
}

// ── Cart page: update quantity
function dermiqCartChange(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(function(r) { return r.json(); })
  .then(function() {
    // Re-check discount before reload so banner/button are correct on new page
    setTimeout(function() { window.location.reload(); }, 50);
  });
}

// ═══════════════════════════════════════════════════════════════════
// DERMIQ PREMIUM MOTION ENGINE — Jacob & Co / Rolex level
// ═══════════════════════════════════════════════════════════════════

(function () {
  'use strict';

  // ── Cursor: dot + trailing ring ──────────────────────────────────
  var ring = document.createElement('div');
  ring.className = 'dermiq-cursor-ring';
  document.body.appendChild(ring);

  var mouseX = 0, mouseY = 0;
  var ringX  = 0, ringY  = 0;
  var ringLerp = 0.10;

  document.addEventListener('mousemove', function (e) {
    mouseX = e.clientX; mouseY = e.clientY;
  });

  document.addEventListener('mousedown', function () { ring.classList.add('clicking'); });
  document.addEventListener('mouseup',   function () { ring.classList.remove('clicking'); });

  document.querySelectorAll('a, button, .product-card, .bundle-card, .formula-card, [data-magnetic]')
    .forEach(function (el) {
      el.addEventListener('mouseenter', function () { ring.classList.add('hovering'); });
      el.addEventListener('mouseleave', function () { ring.classList.remove('hovering'); });
    });

  function lerpRing() {
    ringX += (mouseX - ringX) * ringLerp;
    ringY += (mouseY - ringY) * ringLerp;
    ring.style.left = ringX + 'px';
    ring.style.top  = ringY + 'px';
    requestAnimationFrame(lerpRing);
  }
  lerpRing();

  // ── Parallax engine ──────────────────────────────────────────────
  var parallaxEls = [];

  function initParallax() {
    document.querySelectorAll('[data-parallax]').forEach(function (el) {
      parallaxEls.push({
        el: el,
        speed: parseFloat(el.getAttribute('data-parallax')) || 0.15
      });
    });
  }

  function tickParallax() {
    var scrollY = window.scrollY;
    parallaxEls.forEach(function (p) {
      var rect   = p.el.getBoundingClientRect();
      var center = rect.top + rect.height / 2 - window.innerHeight / 2;
      p.el.style.transform = 'translateY(' + (center * p.speed * -1) + 'px)';
    });
    requestAnimationFrame(tickParallax);
  }

  // ── Split-text reveal ────────────────────────────────────────────
  function initSplitText() {
    document.querySelectorAll('[data-split]').forEach(function (el) {
      var lines = el.innerHTML.split('<br>');
      if (lines.length < 2) {
        // Split on natural line breaks by wrapping each word
        var text = el.textContent.trim();
        el.innerHTML = '<span class="split-line"><span class="split-inner">' + text + '</span></span>';
      } else {
        el.innerHTML = lines.map(function (l) {
          return '<span class="split-line"><span class="split-inner">' + l + '</span></span>';
        }).join('');
      }
    });
  }

  // ── Enhanced intersection observer ──────────────────────────────
  var revealObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e, i) {
      if (e.isIntersecting) {
        setTimeout(function () {
          e.target.classList.add('visible');
          // Also reveal split-inner children
          e.target.querySelectorAll('.split-inner').forEach(function (s) {
            s.classList.add('visible');
          });
        }, i * 60);
        revealObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.08 });

  function initReveals() {
    document.querySelectorAll('.reveal, .reveal-up, .reveal-left, [data-split]')
      .forEach(function (el) { revealObs.observe(el); });
  }

  // ── Counter animation ────────────────────────────────────────────
  function animateCounter(el) {
    var target  = parseFloat(el.getAttribute('data-target') || el.textContent);
    var suffix  = el.getAttribute('data-suffix') || '';
    var prefix  = el.getAttribute('data-prefix') || '';
    var duration = 1800;
    var start   = null;
    var isFloat = target % 1 !== 0;

    function step(ts) {
      if (!start) start = ts;
      var prog = Math.min((ts - start) / duration, 1);
      var ease = 1 - Math.pow(1 - prog, 3);
      var val  = target * ease;
      el.textContent = prefix + (isFloat ? val.toFixed(1) : Math.round(val)) + suffix;
      if (prog < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  var counterObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        animateCounter(e.target);
        counterObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.5 });

  function initCounters() {
    document.querySelectorAll('.count-up[data-target]').forEach(function (el) {
      counterObs.observe(el);
    });
  }

  // ── Ambient background drift on mousemove ─────────────────────
  function initAmbient() {
    document.querySelectorAll('.ambient-bg').forEach(function (bg) {
      var section = bg.parentElement;
      section.addEventListener('mousemove', function (e) {
        var rect = section.getBoundingClientRect();
        var nx = (e.clientX - rect.left) / rect.width  - 0.5;
        var ny = (e.clientY - rect.top)  / rect.height - 0.5;
        bg.style.transform = 'translate(' + (nx * 28) + 'px,' + (ny * 18) + 'px) scale(1.04)';
      });
      section.addEventListener('mouseleave', function () {
        bg.style.transform = '';
      });
    });
  }

  // ── Drag-scroll horizontal strip ────────────────────────────────
  function initHScroll() {
    document.querySelectorAll('.hscroll-track').forEach(function (track) {
      var isDragging = false, startX, scrollLeft;

      track.addEventListener('mousedown', function (e) {
        isDragging = true;
        startX     = e.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
        track.style.userSelect = 'none';
      });
      track.addEventListener('mouseleave', function () { isDragging = false; });
      track.addEventListener('mouseup',    function () { isDragging = false; });
      track.addEventListener('mousemove', function (e) {
        if (!isDragging) return;
        e.preventDefault();
        var x    = e.pageX - track.offsetLeft;
        var walk = (x - startX) * 1.4;
        track.scrollLeft = scrollLeft - walk;
      });
    });
  }

  // ── Side scroll progress bar ────────────────────────────────────
  function initSideProgress() {
    var bar = document.createElement('div');
    bar.className = 'scroll-progress-side';
    document.body.appendChild(bar);
    window.addEventListener('scroll', function () {
      var pct = (window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100;
      bar.style.height = pct + '%';
    }, { passive: true });
  }

  // ── Video hero: pause/play on visibility ────────────────────────
  function initVideoHero() {
    document.querySelectorAll('.video-hero video').forEach(function (vid) {
      vid.muted    = true;
      vid.autoplay = true;
      vid.loop     = true;
      vid.playsInline = true;
      vid.play().catch(function () {});

      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { vid.play().catch(function(){}); }
          else { vid.pause(); }
        });
      }, { threshold: 0.2 });
      obs.observe(vid);
    });
  }

  // ── Float animation on hero bottle ──────────────────────────────
  function initFloatElements() {
    document.querySelectorAll('.hero-bottle, .pg-bottle').forEach(function (el) {
      el.classList.add('float-y');
    });
    document.querySelectorAll('.hero-product-image').forEach(function (el) {
      el.classList.add('float-y-slow');
    });
  }

  // ── Magnetic buttons ─────────────────────────────────────────────
  function initMagnetic() {
    document.querySelectorAll('[data-magnetic]').forEach(function (el) {
      el.addEventListener('mousemove', function (e) {
        var rect = el.getBoundingClientRect();
        var cx   = rect.left + rect.width  / 2;
        var cy   = rect.top  + rect.height / 2;
        var dx   = (e.clientX - cx) * 0.32;
        var dy   = (e.clientY - cy) * 0.32;
        el.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
      });
      el.addEventListener('mouseleave', function () {
        el.style.transform = '';
        el.style.transition = 'transform .5s var(--slow)';
        setTimeout(function () { el.style.transition = ''; }, 500);
      });
    });
  }

  // ── Nav: hide on scroll down, show on scroll up (Rolex style) ──
  function initSmartNav() {
    var nav = document.getElementById('dermiqNav');
    if (!nav) return;
    var lastY = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y > 120) {
        if (y > lastY + 4) {
          nav.style.transform = 'translateY(-100%)';
          nav.style.transition = 'transform .4s var(--slow)';
        } else if (y < lastY - 4) {
          nav.style.transform = 'translateY(0)';
        }
      } else {
        nav.style.transform = 'translateY(0)';
      }
      lastY = y;
    }, { passive: true });
  }

  // ── Stagger .reveal children inside sections ────────────────────
  function initStaggerReveal() {
    document.querySelectorAll('.products-grid, .bundles-grid, .formula-grid, .reviews-grid, .stats-strip')
      .forEach(function (grid) {
        Array.prototype.forEach.call(grid.children, function (child, i) {
          child.classList.add('reveal-up');
          child.style.transitionDelay = (i * 0.07) + 's';
          revealObs.observe(child);
        });
      });
  }

  // ── INIT ────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    initParallax();
    initSplitText();
    initReveals();
    initCounters();
    initAmbient();
    initHScroll();
    initSideProgress();
    initVideoHero();
    initFloatElements();
    initMagnetic();
    initSmartNav();
    initStaggerReveal();
    tickParallax();
  });

})();

/* ── LUXURY ANIMATION ENGINE (Lenis + GSAP + IntersectionObserver) ──────── */
(function () {
  'use strict';

  // ── 1. Lenis smooth scroll ────────────────────────────────────────────────
  var lenis;
  function initLenis() {
    if (typeof Lenis === 'undefined') return;
    lenis = new Lenis({
      duration: 1.4,
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      direction: 'vertical',
      smooth: true,
      smoothTouch: false
    });

    // Connect to GSAP ticker if available
    if (typeof gsap !== 'undefined') {
      gsap.ticker.add(function (time) { lenis.raf(time * 1000); });
      gsap.ticker.lagSmoothing(0);
    } else {
      // Fallback RAF loop
      function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
      requestAnimationFrame(raf);
    }
  }

  // ── 2. Reveal observer (dq-reveal, dq-fade-up, dq-img-reveal) ────────────
  function initLuxuryReveals() {
    var selectors = '.dq-reveal, .dq-fade-up, .dq-img-reveal';
    var els = document.querySelectorAll(selectors);
    if (!els.length) return;

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { obs.observe(el); });
  }

  // ── 3. Magnetic buttons (GSAP) ────────────────────────────────────────────
  function initMagneticGSAP() {
    if (typeof gsap === 'undefined') return;
    document.querySelectorAll('.dq-magnetic').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var x = e.clientX - r.left - r.width / 2;
        var y = e.clientY - r.top - r.height / 2;
        gsap.to(btn, { x: x * 0.3, y: y * 0.3, duration: 0.4, ease: 'power2.out' });
      });
      btn.addEventListener('mouseleave', function () {
        gsap.to(btn, { x: 0, y: 0, duration: 0.7, ease: 'elastic.out(1,0.5)' });
      });
    });
  }

  // ── 4. Hero cinematic load ────────────────────────────────────────────────
  function initHeroReveal() {
    if (typeof gsap === 'undefined') return;
    var hero = document.querySelector('.video-hero, .hero-section, [class*="hero"]');
    if (!hero) return;
    var img   = hero.querySelector('img, video');
    var title = hero.querySelector('h1, .hero-title, [class*="title"]');
    var sub   = hero.querySelector('p, .hero-sub, [class*="sub"], [class*="lead"]');
    var cta   = hero.querySelector('a.btn, button.btn, .hero-cta, [class*="cta"]');

    var tl = gsap.timeline({ defaults: { ease: 'power3.out' } });
    if (img)   tl.from(img,   { scale: 1.06, duration: 1.8 });
    if (title) tl.from(title, { y: 50, opacity: 0, duration: 0.9 }, '-=1.2');
    if (sub)   tl.from(sub,   { y: 30, opacity: 0, duration: 0.7 }, '-=0.6');
    if (cta)   tl.from(cta,   { y: 20, opacity: 0, duration: 0.5 }, '-=0.4');
  }

  // ── 5. Scroll storytelling sections ───────────────────────────────────────
  function initScrollStory() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);

    // Scroll-triggered entrance for formula-grid, reviews, etc.
    gsap.utils.toArray('.formula-grid > *, .reviews-grid > *, .products-grid > *').forEach(function (el, i) {
      gsap.from(el, {
        y: 40, opacity: 0,
        duration: 0.7,
        delay: (i % 4) * 0.1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 88%',
          toggleActions: 'play none none none'
        }
      });
    });

    // Horizontal product strip
    var hTrack = document.querySelector('.dq-h-track');
    if (hTrack) {
      var items = gsap.utils.toArray('.dq-h-track > *');
      if (items.length > 2) {
        gsap.to(items, {
          xPercent: -100 * (items.length - 1.5),
          ease: 'none',
          scrollTrigger: {
            trigger: hTrack.parentElement,
            pin: true,
            scrub: 1.2,
            end: function () { return '+=' + hTrack.scrollWidth; }
          }
        });
      }
    }
  }

  // ── INIT ─────────────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    /* Lenis disabled for performance */
    initLuxuryReveals();
    initMagneticGSAP();
    initHeroReveal();
    initScrollStory();
  });

})();
/* ── END LUXURY ANIMATION ENGINE ─────────────────────────────────────────── */

// ── Mini-cart hover ──────────────────────────────────────────────
(function initMiniCart() {
  var wrap     = document.getElementById('bagWrap');
  var drop     = document.getElementById('miniCart');
  var itemsEl  = document.getElementById('mcItems');
  var countEl  = document.getElementById('mcCount');
  var subEl    = document.getElementById('mcSubtotal');
  var codeIn   = document.getElementById('mcCodeInput');
  var codeBtn  = document.getElementById('mcCodeBtn');
  if (!wrap || !drop) return;

  var hideTimer, loaded = false;

  function openCart() {
    clearTimeout(hideTimer);
    drop.classList.add('mc-open');
    if (!loaded) { loaded = true; refreshCart(); }
  }
  function closeCart() {
    hideTimer = setTimeout(function() { drop.classList.remove('mc-open'); }, 180);
  }

  wrap.addEventListener('mouseenter', openCart);
  wrap.addEventListener('mouseleave', closeCart);
  drop.addEventListener('mouseenter', function() { clearTimeout(hideTimer); });
  drop.addEventListener('mouseleave', closeCart);

  // ── Locale-aware money formatter ──────────────────────────────
  // 1) window.Shopify.formatMoney() if available
  // 2) Intl.NumberFormat with document lang + Shopify.currency.active
  // 3) Fallback EUR/SEK with Swedish formatting
  function money(cents) {
    var amount = (cents || 0) / 100;
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        var fmt = (window.Shopify.money_format) || '€{{amount}}';
        return window.Shopify.formatMoney(cents, fmt);
      }
    } catch (e) {}
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var lang = (document.documentElement.lang || navigator.language || 'sv-SE').replace('_', '-');
    try {
      return new Intl.NumberFormat(lang, { style: 'currency', currency: currency }).format(amount);
    } catch (e) {}
    // Final fallback: Swedish formatting
    var sym = currency === 'SEK' ? ' kr' : '€';
    var s = amount.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return currency === 'SEK' ? (s + sym) : (sym + s);
  }

  // ── Mini-cart upsell ──────────────────────────────────────────
  var MC_UPSELL_PRODUCTS = null;
  var upsellEl     = document.getElementById('mcUpsell');
  var upsellListEl = document.getElementById('mcUpsellList');

  function loadUpsellProducts() {
    if (MC_UPSELL_PRODUCTS) return Promise.resolve(MC_UPSELL_PRODUCTS);
    return fetch('/collections/all/products.json?limit=10', { headers: { Accept: 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var products = (data && data.products) || [];
        MC_UPSELL_PRODUCTS = products.map(function(p) {
          var v = (p.variants && p.variants[0]) || {};
          return {
            title: p.title,
            price: Math.round(parseFloat(v.price || '0') * 100),
            vid: v.id
          };
        }).filter(function(p) { return p.vid; });
        return MC_UPSELL_PRODUCTS;
      })
      .catch(function() { return []; });
  }

  function renderUpsell(cart) {
    if (!upsellEl || !upsellListEl) return;
    loadUpsellProducts().then(function(list) {
      var inCart = {};
      (cart.items || []).forEach(function(it) { inCart[it.product_title] = true; });
      var picks = list.filter(function(p) { return !inCart[p.title]; }).slice(0, 2);
      if (!picks.length) { upsellEl.hidden = true; upsellListEl.innerHTML = ''; return; }
      upsellEl.hidden = false;
      upsellListEl.innerHTML = picks.map(function(p) {
        return '<div class="mc-upsell-item">'
          +   '<span class="mc-upsell-name">' + p.title + '</span>'
          +   '<span class="mc-upsell-price">' + money(p.price) + '</span>'
          +   '<button type="button" class="mc-upsell-add" data-vid="' + p.vid + '">+ Lägg till</button>'
          + '</div>';
      }).join('');
      upsellListEl.querySelectorAll('.mc-upsell-add').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var vid = btn.getAttribute('data-vid');
          if (typeof window.dermiqAddToCart === 'function') {
            window.dermiqAddToCart(vid, 1, btn);
          }
        });
      });
    });
  }


  function refreshCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        // update nav count
        var navCount = document.getElementById('cartCount');
        if (navCount) navCount.textContent = cart.item_count;
        var dot = document.getElementById('cartDot');
        if (dot) dot.style.display = cart.item_count > 0 ? '' : 'none';
        // update mini-cart header
        if (countEl) countEl.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
        if (subEl)   subEl.textContent   = money(cart.total_price);
        // render items
        if (!itemsEl) return;
        if (cart.items.length === 0) {
          itemsEl.innerHTML = '<p class="mc-empty">Your bag is empty.</p>';
          renderUpsell(cart);
          return;
        }
        itemsEl.innerHTML = cart.items.map(function(it) {
          var imgHtml = it.image
            ? '<img class="mc-item-img" src="' + it.image + '" alt="" width="60" height="60">'
            : '<div class="mc-item-img mc-item-img--ph"></div>';
          var varHtml = (it.variant_title && it.variant_title !== 'Default Title')
            ? '<span class="mc-item-variant">' + it.variant_title + '</span>' : '';
          return '<div class="mc-item">'
            + '<a href="' + it.url + '" class="mc-item-img-wrap">' + imgHtml + '</a>'
            + '<div class="mc-item-body">'
            +   '<span class="mc-item-name">' + it.product_title + '</span>'
            +   varHtml
            +   '<div class="mc-item-row">'
            +     '<span class="mc-item-qty">×' + it.quantity + '</span>'
            +     '<span class="mc-item-price">' + money(it.line_price) + '</span>'
            +   '</div>'
            + '</div>'
            + '</div>';
        }).join('');
        renderUpsell(cart);
      })
      .catch(function() {});
  }

  // Discount code: redirect to checkout with code pre-applied
  if (codeBtn && codeIn) {
    codeBtn.addEventListener('click', function() {
      var code = codeIn.value.trim();
      if (code) window.location.href = '/checkout?discount=' + encodeURIComponent(code);
    });
    codeIn.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') codeBtn.click();
    });
  }

  // Re-fetch whenever cart changes (after add-to-cart calls)
  document.addEventListener('dermiq:cart:updated', function() {
    loaded = true;
    refreshCart();
  });
})();
